require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.3@core-js/library/modules/es7.symbol.async-iterator.js
// module id = 465
// module chunks = 0 1